import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Select, { StylesConfig } from "react-select";

export const FILTER_PREFIXES = {
    BLOCK: 'b',
    UNIT: 'u',
    USER: 'usr',
    CATEGORY: 'cat',
    STATUS: 'st',
    VISITOR_TYPE: 'vt',
    ENTRANCE: 'e',
}

const styles = {
    control: (provided, state) => ({
        ...provided,
        borderRadius: '3px',
        border: state.isSelected
            ? '1px solid var(--input-border-color-active)'
            : state.isFocused
                ? '1px solid var(--input-border-color-active)'
                : '1px solid var(--input-border-color)',
        boxShadow: state.isFocused
            ? '0 0 5px #cacaca'
            : 'inset 0 1px 2px rgb(10 10 10 / 10%)',
    }),
    valueContainer: (provided) => ({
        ...provided,
        flexWrap: 'initial',
        paddingRight: 0,
    }),
    input: (provided) => ({
        ...provided,
        height: 'auto',
        margin: 0,
        padding: 0,
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: 'var(--siteconfig-ui-btn-stdcolor)',
        paddingLeft: 0,
    }),
    clearIndicator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 50,
    }),
    multiValue: (styles, { data }) => {
        return {
            ...styles,
            color: 'white',
            backgroundColor: 'var(--siteconfig-ui-btn-stdcolor)'
        };
    },
    multiValueLabel: (styles, { data }) => ({
        ...styles,
        color: data.color,
    }),
    multiValueRemove: (styles, { data }) => ({
        ...styles,
        paddingLeft: 0,
        paddingRight: 2,
    }),
};

const MultiFilterInput = (props) => {
    if (!props.options) {
        return null;
    }

    return <Select
        placeholder="Filter by"
        className="react-select-multi-container margin-bottom-1"
        classNamePrefix="react-select-multi"
        isMulti
        options={props.options}
        value={props.value}
        styles={styles}
        onChange={(options) => props.onChange(options)}
    />
}

MultiFilterInput.propTypes = {
    options: PropTypes.array,
    value: PropTypes.array,
    onChange: PropTypes.func,
}

export default MultiFilterInput;
